// extracted by mini-css-extract-plugin
export default {"action":"Action_action__QgFRy"};